import { DataGridProvider } from "../../../core/components/data-grid/DataGridContext";
import SimpleLayout from "../../../core/components/layout/SimpleLayout";
import AppLogDataGrid from "./AppLogDataGrid";
import { Card } from "antd";
import { t } from "i18next";
import AppLogFilter from "./AppLogFilter";


export default function AppLogDataGridApp() {
    return (
        <SimpleLayout fullWidth={true}>
            <Card title={t('AppLog')}>
                <DataGridProvider
                    defaultFilter={{ Validate: true }}
                >
                    <AppLogFilter />
                    <AppLogDataGrid />
                </DataGridProvider>
            </Card>
        </SimpleLayout>
    )
}